import { render, staticRenderFns } from "./PrivacyLinkAndModal.vue?vue&type=template&id=1ddf8c30&scoped=true&"
import script from "./PrivacyLinkAndModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyLinkAndModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf8c30",
  null
  
)

export default component.exports